<template>
	<div class="tab" :class="{ open }" :style="tabStyle" @click="onClick">
		<div class="tab__header" :style="headerStyle" @click="onClickHeader">
			<slot name="header" />
		</div>
		<div class="tab__content" :style="contentStyle">
			<div class="tab__inner" ref="content" :style="innerStyle">
				<slot name="content" />
			</div>
		</div>
	</div>
</template>

<script>
// Header height in rems
const HEADER_HEIGHT = 3.5

// Unit adders
const px = n => `${n}px`
const rem = n => `${n}rem`

export default {
	name: 'Tab',
	props: {
		height: Number,
		open: Boolean
	},
	data() {
		return {
			contentHeight: 0
		}
	},
	computed: {
		vertPadding() {
			return `calc(${px(this.height / 2)} - ${rem(HEADER_HEIGHT / 2)})`
		},
		tabStyle() {
			return {
				minHeight: px(this.height)
			}
		},
		headerStyle() {
			return {
				paddingTop: this.vertPadding,
				height: `calc(${rem(HEADER_HEIGHT)})`
			}
		},
		contentStyle() {
			return {
				height: px(this.open ? this.contentHeight : 0),
				opacity: this.open ? 1 : 0
			}
		},
		innerStyle() {
			return {
				paddingBottom: this.vertPadding
			}
		}
	},
	methods: {
		measure() {
			this.contentHeight = this.$refs.content.offsetHeight
		},
		onClick() {
			if (!this.open) {
				this.measure()
				this.$emit('toggle')
			}
		},
		onClickHeader(event) {
			if (this.open) {
				event.stopPropagation()
				this.$emit('toggle')
			}
		}
	},
	mounted() {
		this.measure()
	},
	watch: {
		innerStyle() {
			this.$nextTick(this.measure)
		},
		'$screen.width'() {
			this.measure()
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.tab {
	-webkit-tap-highlight-color: transparent;

	&__header,
	&__content {
		width: 100%;
	}
	&__header {
		box-sizing: content-box;
		-webkit-tap-highlight-color: transparent;
	}
	&__content {
		transition: height $anim-slide, opacity $anim-tab-spd;
	}
	&__content,
	&__inner {
		overflow: hidden;
	}
	&__inner {
		box-sizing: border-box;
	}

	// Open/closed specific styling

	&:not(.open) {
		cursor: pointer;
	}
	&.open &__header {
		cursor: pointer;
	}
}
</style>
